import React from "react";
import { Box, Typography, Chip, Drawer } from "@mui/material";
import { Person as PersonIcon } from "@mui/icons-material";
import { getRoleLabel } from "../../utils/roleLabels";
import { getStatusChipSx } from "./constants";
import { DrawerHeader, InfoRow } from "../../components/atoms";

import { COLORS, TYPO } from "../../styles/uiConstants";
import { formatPhoneDisplay } from "../../components/atoms/PhoneInput";

function SectionLabel({ children }) {
  return (
    <Typography
      sx={{
        px: 2.5,
        pt: 2.5,
        pb: 1,
        fontSize: TYPO.label,
        fontWeight: 700,
        color: COLORS.slate500,
        textTransform: "uppercase",
        letterSpacing: "0.06em",
      }}
    >
      {children}
    </Typography>
  );
}

function Row({ label, value, noBorder }) {
  return (
    <InfoRow label={label} noBorder={noBorder}>
      <Typography fontWeight={600} fontSize={TYPO.body} sx={{ pt: 0.4, color: COLORS.slate800, wordBreak: "break-word" }}>
        {value}
      </Typography>
    </InfoRow>
  );
}

export default function UserDetailDrawer({ open, onClose, user }) {
  if (!open || !user) return null;

  return (
    <Drawer
      anchor="right"
      open={open}
      onClose={onClose}
      PaperProps={{
        sx: {
          width: { xs: "100%", sm: 420, md: 480 },
          bgcolor: COLORS.white,
          display: "flex",
          flexDirection: "column",
        },
      }}
    >
      <DrawerHeader
        icon={<PersonIcon />}
        title={`${user.name || ""} ${user.surname || ""}`.trim()}
        subtitle={getRoleLabel(user.role)}
        onClose={onClose}
      />

      <Box sx={{ flex: 1, overflowY: "auto", pb: 2 }}>
        <SectionLabel>Kişisel Bilgiler</SectionLabel>
        <Row label="Email" value={user.email} />
        <Row label="Telefon" value={formatPhoneDisplay(user.phone)} />
        <Row label="TC No" value={user.tcNo} />
        <Row label="Rol" value={getRoleLabel(user.role)} />

        <SectionLabel>Hesap Durumu</SectionLabel>
        <InfoRow label="Durum">
          <Chip label={user.accountStatus} size="small" sx={getStatusChipSx(user.accountStatus)} />
        </InfoRow>
        {user.statusReason && <Row label="Sebep" value={user.statusReason} />}
        <Row
          label="Son Giriş"
          value={user.lastLogin ? new Date(user.lastLogin).toLocaleDateString("tr-TR") : "Henüz giriş yapmadı"}
        />
        <Row
          label="Kayıt Tarihi"
          value={user.createdAt ? new Date(user.createdAt).toLocaleDateString("tr-TR") : "Bilinmiyor"}
          noBorder
        />
      </Box>
    </Drawer>
  );
}
